import React from 'react';

import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { RADIAL_BAR_FILLS } from 'src/features/home/types';

type Props = {
    dataKey: string;
    data?: { [key: string]: string | number }[];
    children?: React.ReactNode;
};

export default function HalfPieChart({ data, dataKey, children }: Props) {
    return (
        <div className="relative flex h-full w-full items-center justify-center">
            <ResponsiveContainer className="absolute aspect-square min-h-50" width="100%" height="100%">
                <PieChart>
                    <Pie
                        startAngle={180}
                        endAngle={0}
                        data={data}
                        dataKey={dataKey}
                        cx="50%"
                        cy="75%"
                        innerRadius="70%"
                        outerRadius="100%"
                        isAnimationActive
                    >
                        {data?.map((_entry, i) => (
                            <Cell key={i} fill={RADIAL_BAR_FILLS[i % RADIAL_BAR_FILLS.length]} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-x-0 top-25">{children}</div>
        </div>
    );
}
